import { render, staticRenderFns } from "./SortTree.vue?vue&type=template&id=0f339f9f&"
import script from "./SortTree.vue?vue&type=script&lang=js&"
export * from "./SortTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports